import { useEffect } from "react";
import { AiOutlineCheck } from "react-icons/ai";

import s from "./SuccessToast.module.css";

export interface SuccessToastProps {
  message: string;
  durationMs?: number;
  onDismiss: () => void;
}

export const SuccessToast = ({
  message,
  durationMs = 4000,
  onDismiss,
}: SuccessToastProps) => {
  useEffect(() => {
    const timer = setTimeout(() => onDismiss(), durationMs);
    return () => clearTimeout(timer);
  }, [durationMs, onDismiss]);

  return (
    <div
      role="status"
      data-testid="feedback-toast"
      className={s.toast}
      onClick={onDismiss}
    >
      <span aria-hidden="true" className={s.icon}>
        <AiOutlineCheck />
      </span>
      <span className={s.message}>{message}</span>
    </div>
  );
};
